<template>
  <div>
    <div v-if="hasPermission" class="nav-link btn btn-sm py-0 icon-bullhorn am-notification-button" @click="toggleNotification()">
      <font-awesome-icon icon="bullhorn" size="lg" class="am-mt-5px align-top"></font-awesome-icon>
      <span class="fa-stack fa-1x am-mt-5px" v-if="unreadCount > 0">
        <font-awesome-icon class="notification-alert" icon="circle" size="lg"></font-awesome-icon>
        <span class="fa-stack-1x notification-number">
           <span><strong>{{unreadCount}}</strong></span>
        </span>
      </span>
    </div>
    <div v-bind:class="{ collapse: !display }">
      <div class="am-notification">
        <div class="am-notification-header">
          <span>Notifications</span>
          <div class="btn-group notification-buttons">
            <button type="button" class="btn btn-success btn-xs" :class="{active: filterCriteria === 'all'}" @click="filterCriteria = 'all'" title="View all the Notifications">All</button>
            <button type="button" class="btn btn-success btn-xs" :class="{active: filterCriteria === 'new'}" @click="filterCriteria = 'new'" title="View all the New/Unread Notifications">New</button>
            <button type="button" class="btn btn-success btn-xs" :class="{active: filterCriteria === 'read'}" @click="filterCriteria = 'read'"  title="View all the Read Notifications">Read</button>
          </div>
        </div>
        <div class="am-notification-body">
          <table v-for="notification in filteredNotifications" class="am-notification-card" :key="notification.id" v-bind:style='{"background-color" : (notification.readAt? "#c6ecd9" : "#ccf5ff" )}'>
            <thead>
            <tr>
              <th>{{notification.title}}</th>
              <th>
                <font-awesome-icon class="am-notification-delete-icon" icon="times-circle" @click="confirmDelete(notification.id)" title="Remove Notification"/>
                <input type="checkbox" style="float:right; cursor:pointer;" v-on:click="toggleNotificationColor(notification)" v-model="notification.readAt" :title="toggleHoverMessage(notification)">
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td><span class="notification-message">{{notification.notification_message.message}}</span></td>
            </tr>
            <tr>
              <td>
                <span class="am-notification-reply">
                  <font-awesome-icon icon="clock"/>
                  {{notification.trandate}} - {{ notification.from_user ? notification.from_user.name : ''}}
                </span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="am-notification-footer">
          <a class="btn btn-success" @click="notificationCreate" title="Click To Create A New Notification">Add</a>
        </div>
      </div>
      <modal name="confirmDelete" classes="am-vue-modal" :clickToClose="false" :pivotY="0.5" height="200px" width="370px">
        <confirm-Delete :index="deleteId" @deleteNotification="deleteNotification"></confirm-Delete>
      </modal>
      <modal name="notificationCreate" classes="am-vue-modal" width="330px" height="335px" :pivotY="0.5" :clickToClose="false" :adaptive="true">
        <notification-create @refreshList="refreshList" v-show="true" ></notification-create>
      </modal>
    </div>
  </div>
</template>

<script>
import api from './../http'
import confirmDelete from './confirmDelete.vue'
import NotificationCreate from './NotificationCreate'
export default {
  data: function () {
    return {
      name: 'Notification',
      deleteId: 0,
      filterCriteria: 'all',
      display: false
    }
  },

  computed: {
    filteredNotifications () {
      var self = this
      return this.data.filter(function (notification) {
        switch (self.filterCriteria) {
          case 'all':
            return true
          case 'new':
            return notification.readAt === null
          case 'read':
            return notification.readAt !== null
        }
      })
    },
    unreadCount () {
      return this.data.filter(i => i.readAt === null).length
    },
    hasPermission () {
      return (this.$store.state.auth.permissions.PRbackOffice === 1) || (this.$store.state.auth.permissions.PRallowNotification === 1 && this.$store.state.auth.config.liteSwitch >= 3)
    }
  },

  asyncComputed: {
    data: {
      get () {
        return api.authenticated().then(authStore => {
          return api.makeRequest('/notifications/' + authStore.user.id).then(
            data => {
              if (typeof data.data.notifications === 'undefined') {
                return []
              }
              return data.data.notifications
            }
          )
        }).catch(error => {
          console.error('notify-error', error)
          return []
        })
      },
      default: []
    }
  },

  methods: {
    deleteNotification: function (index) {
      var self = this
      api.postRequest('notifications/' + index + '/hide',
        {}
      ).then(function (response) {
        self.refreshList()
        console.log('response', response)
      }).catch(function (error) {
        console.log(error)
      })
    },

    toggleNotificationColor: function (notification) {
      var self = this
      api.postRequest('notifications/' + notification.id + '/toggle_read_at',
        {}
      ).then(function (response) {
        self.refreshList()
        console.log('response', response)
      }).catch(function (error) {
        console.log(error)
      })
    },

    confirmDelete: function (id) {
      this.deleteId = id
      this.$modal.show('confirmDelete')
    },

    notificationCreate: function () {
      this.$modal.show('notificationCreate')
    },

    toggleHoverMessage (notification) {
      return notification.readAt ? 'Click To Mark As Unread' : 'Click To Mark As Read'
    },

    toggleNotification: function () {
      this.display = !this.display
    },

    refreshList: function () {
      this.$asyncComputed.data.update()
    }
  },

  components: {
    'confirmDelete': confirmDelete,
    NotificationCreate
  }
}
</script>

<style scoped>
  .v--modal-overlay {
    background-color: rgba(0,0,0,0.7);
  }

  .am-notification{
    display: block;
    width: 270px;
    height: auto;
    margin-left: 50px;
    z-index: 1;
    background-color: #ffffff;
    position: absolute;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.4);
    right: 12px;
  }
  .am-notification-header {
    height: 40px;
    background-color: #2A95CC;
    padding: 8px;
    top: 0;
    position: sticky;
    font-size: 16px;
  }

  .am-notification-header span{
    color: white;
    font-weight: bold;
  }

  .notification-buttons{
    float: right;
  }

  .notification-buttons button{
    padding: 1px 5px;
  }

  .am-notification-body{
    overflow-y: auto;
    resize: vertical;
    max-height: 600px;
    color: black;
  }

  .am-notification-card{
    display: block;
    border-bottom: 1px solid grey;
    padding: 5px 7px 5px 5px;
    vertical-align: top;
  }

  .notification-message {
    word-wrap: break-word;
    display: block;
    width: 230px;
  }

  .am-notification-card thead th:first-child{
    font-size: 14px;
    width: 250px;
    padding: 0px 0px 18px 0px;
    line-height: 20px;
  }

  .am-notification-card td {
    font-size: 11px;
    padding: 0px 0px 0px 0px;
    line-height: 20px;
  }

  .am-notification-delete-icon {
    font-size: 16px;
    color: red;
    float: right;
    cursor: pointer;
  }

  input[type='checkbox'] {
    width:16px;
    height:16px;
    margin-top: 5px;
  }

  .am-notification-reply {
    background-color: #999;
    display: inline;
    padding: 3px;
    font-weight: bold;
    line-height: 1;
    color: #fff;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: .25em;
  }

  .am-notification-footer {
    height: 50px;
    width:100%;
    background-color: #2A95CC;
    position:absolute;
    box-shadow: 0px 10px 20px 0px rgba(0,0,0,0.4);
  }

  .am-notification-footer a {
    padding: 5px 15px;
    margin-left: 10px;
    margin-top: 8px;
  }

  .icon-bullhorn {
    background-color: #ffffff;
    color: #2A95CC;
    margin-left: 3px;
  }

  .icon-bullhorn:hover {
    background-color: #2A95CC;
    color: white;
    cursor: pointer;
  }

  .notification-alert {
    color: red;
    font-size: 20px;
  }

  .notification-number {
    color: white;
  }

  .notification-number span {
    font-size:12px;
    display:block;
  }

  .am-notification-button {
    height: 29px;
  }

  .am-mt-5px {
    margin-top: 5px;
  }

  .fa-stack {
    line-height: 1.8em;
  }

  .btn-sm {
    padding: 5px 10px;
    font-size: 12px;
    border-radius: 0px;
  }

</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
</style>
